import { createSlice } from "@reduxjs/toolkit";

const editarviajeState = {
  editarviajedataCab: [],
  editarviajedataDet: [],
};

const editarviajeSlice = createSlice({
  name: "editarviaje",
  initialState: editarviajeState,
  reducers: {
    EditarViajeDataCab: (state, action) => {
      state.editarviajedataCab = action.payload;
    },
    EditarViajeDataDet: (state, action) => {
      state.editarviajedataDet = action.payload;
    },
    CleanEditarViajeData: () => editarviajeState,
  },
});

export const { EditarViajeDataCab, EditarViajeDataDet, CleanEditarViajeData } = editarviajeSlice.actions;

export default editarviajeSlice.reducer;
